export default __webpack_public_path__ + "static/media/copy_link-gray.6eebeead.svg";